export const PAGE_ROUTES = {
  HOME: "/",
  NOT_FOUND: "/not-found",
  FOTGOT_PASSWORD: "/forgot-password",
  LOGIN: "/login",
  MIGRATE: "/migrate",
  ORGANIZATIONS: "/organizations",
  SUCCESS: "/success",
};
